import React, { useState } from 'react';

const InputField = ({ label, name, value, onChange, type, requiredLength, errorMessage }) => {
  const [error, setError] = useState('');

  const handleValidation = (e) => {
    const inputValue = e.target.value;

    if (requiredLength && inputValue.length !== requiredLength) {
      setError(errorMessage || `This field must be exactly ${requiredLength} characters.`);
    } else {
      setError(''); // Clear the error
    }

    onChange(e); // Pass the value to the parent
  };

  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">{label}</label>
      <input
        type={type || 'text'}
        name={name}
        value={value}
        onChange={handleValidation}
        className={`border border-gray-300 rounded-lg px-4 py-2 w-full ${
          error ? 'border-red-500' : ''
        }`}
     //   placeholder={`Enter ${label}`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default InputField;
